<script>
  import { selectedWorkshopID, userWorkshops } from "../scripts/stores.js";
  import { formatTimestamp } from "../scripts/utils.js";

  let workshop;
  let alreadyRegistered = false;
  console.log($userWorkshops);
  console.log($selectedWorkshopID);
  $: {
    if ($selectedWorkshopID in $userWorkshops) {
      workshop = $userWorkshops[$selectedWorkshopID];
      alreadyRegistered = true;
    } else {
      alreadyRegistered = false;
    }
  }
</script>

<main class="page">
  {#if alreadyRegistered}
    <h1>Thank you!</h1>
    <h3>
      I'm looking forward to working with you! <br /> Here are your details:
    </h3>
    <h2>{workshop.title}</h2>
    <h3>{formatTimestamp(workshop.startTime).date}</h3>
    <h3>{formatTimestamp(workshop.startTime).time}</h3>
    <div>Zoom Invitation:</div>
    <div>{@html workshop.zoomInvite}</div>
    <p>If you have any issues, please email support@synthase.cc.</p>
  {:else}
    <p>
      Pulling up your workshop information. If this page gets stuck here, please
      email support@synthase.cc.
    </p>
  {/if}
</main>

<style>
</style>
